import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import PoliticasPrivacidadGrid from './PoliticasPrivacidadGrid.jsx'
import PoliticasPrivacidadAbm from './PoliticasPrivacidadAbm.jsx'
import { FormattedMessage } from 'react-intl';

class PoliticasPrivacidad extends Component {
	render() {
		return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
						<h3 className="content-header-title">
							<FormattedMessage id="politicasPrivacidad.titulo" defaultMessage="Administración de Políticas de Privacidad" />
						</h3>
					</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={PoliticasPrivacidadGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <PoliticasPrivacidadAbm {...props} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/nueva-version`} render={(props) => <PoliticasPrivacidadAbm {...props} action="NUEVA_VERSION" />} />
						<Route path={`${this.props.match.url}/:id`} render={(props) => <PoliticasPrivacidadAbm {...props} action="VIEW" />} />
					</Switch>
				</div>
			</div>
		);
	}
}

export default PoliticasPrivacidad;
